import styled from 'styled-components';

import { forMd } from '../../../config/_variables';
import BackgroundDesktopImage from '../../../assets/black-friday-2026-bg-desktop.jpg';

const WHITE = '#FFFFFF';
const YELLOW = '#F9AC00';

// Gradiente radial do Figma (Banner-Mobile / PT), igual ao exportado pelo design.
const BackgroundMobile = [
  "data:image/svg+xml;utf8,<svg viewBox='0 0 343 320' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'>",
  "<rect width='100%' height='100%' fill='url(%23g)'/><defs>",
  "<radialGradient id='g' gradientUnits='userSpaceOnUse' cx='0' cy='0' r='10' gradientTransform='matrix(8.4012 9.4717 -25.328 10.519 172 81.5)'>",
  "<stop stop-color='%23782A07' offset='0'/><stop stop-color='%235A2005' offset='0.25'/><stop stop-color='%233C1504' offset='0.5'/>",
  "<stop stop-color='%231E0B02' offset='0.75'/><stop stop-color='%230F0501' offset='0.875'/><stop stop-color='%23000000' offset='1'/>",
  '</radialGradient></defs></svg>',
].join('');

export const BannerWrapper = styled.div`
  align-items: center;
  background: #000000 url("${BackgroundMobile}") no-repeat center / 100% 100%;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  font-feature-settings: 'salt' 1;
  gap: 16px;
  max-width: 343px;
  min-height: 320px;
  overflow: hidden;
  padding: 32px 24px 24px;
  width: 100%;

  ${forMd} {
    background: #000000 url(${BackgroundDesktopImage}) no-repeat center / cover;
    flex-direction: row;
    gap: 48px;
    height: 140px;
    margin-bottom: 24px;
    max-width: none;
    min-height: 0;
    padding: 0 48px;
    width: 948px;
  }
`;

export const Lettering = styled.img`
  display: block;
  flex-shrink: 0;
  height: 120px;
  width: 249px;

  ${forMd} {
    height: 100px;
    width: 207px;
  }
`;

export const ContainerTexts = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 279px;
  text-align: center;

  ${forMd} {
    align-items: flex-start;
    gap: 8px;
    max-width: none;
    text-align: left;
  }
`;

export const Title = styled.p`
  color: ${WHITE};
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
  max-width: 262px;

  ${forMd} {
    max-width: none;
    white-space: nowrap;
  }
`;

export const Highlight = styled.span`
  color: ${YELLOW};
`;

export const Description = styled.div`
  color: ${WHITE};
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${forMd} {
    gap: 0;
    white-space: nowrap;
  }
`;

export const DescriptionLine = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;

export const Offer = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;

  ${forMd} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const OfferHighlight = styled.span`
  color: ${YELLOW};
  font-weight: 700;

  ${forMd} {
    margin-left: 6px;
  }
`;
